import React from 'react';

import { useDate } from '../Context/DateContext';

const useDateFilters = () => {
  const {
    selectedDate,
    customDateChange: customDateChangeContext,
    handleDateChange,
    dateType,
  } = useDate();
  const [openCustom, setOpenCustom] = React.useState(false);

  const handleChangeToday = () => {
    handleDateChange('today');
  };

  const handleChangeLast48h = () => {
    handleDateChange('last48hours');
  };

  const handleChangeLast7Days = () => {
    handleDateChange('last7days');
  };

  const handleChangeLast30Days = () => {
    handleDateChange('last30days');
  };

  const onCloseCustomModal = () => {
    setOpenCustom(false);
  };

  const openCustomModal = () => {
    setOpenCustom(true);
  };

  const customDateChange = ({ startDate, endDate }: { startDate: string; endDate: string }) => {
    customDateChangeContext({ startDate, endDate });
  };

  return {
    selectedDate,
    customDateChange,
    handleChangeToday,
    handleChangeLast48h,
    handleChangeLast7Days,
    handleChangeLast30Days,
    dateType,
    openCustom,
    openCustomModal,
    onCloseCustomModal,
  };
};

export default useDateFilters;
